export const extractBaseNumberFromPartKey = (partKey?: string): string | null => {
  if (partKey && !partKey.includes(".") && partKey.length >= 9) {
    const secondGroup = partKey.substring(3, 6);
    const thirdGroup = partKey.substring(6, 9);
    return `${secondGroup}.${thirdGroup}`;
  }

  if (partKey && partKey.includes(".")) {
    const partKeyGroups = partKey.split(".");
    if (partKey.length >= 11 && partKeyGroups.length >= 3) {
      const [, secondGroup, thirdGroup] = partKeyGroups;
      return `${secondGroup}.${thirdGroup}`;
    }
  }

  return null;
};
